import type { VerticalAlign, TableRow, TableColumn } from 'uikit';
import { Table } from 'uikit';

import cn from 'classnames';
import type { ReactNode, Ref } from 'react';
import { forwardRef } from 'react';

import Styles from './DataTable.module.css';

interface IDataTable {
    data: TableRow[];
    columns: TableColumn<any>[];
    zebraStyle?: 'odd' | 'even';
    borderBetweenColumns?: boolean;
    borderBetweenRows?: boolean;
    outerBorders?: boolean;
    filters?: any;
    onFiltersUpdated?: (value: any) => void;
    onSortBy?: (value: any) => void;
    withHeightLimit?: boolean;
    emptyRowsPlaceholder?: ReactNode;
    getAdditionalClassName?: (variables: any) => string;
    verticalAlign?: VerticalAlign;
}

export const DataTable = forwardRef(
    (
        {
            filters = [],
            data,
            columns,
            zebraStyle = undefined,
            borderBetweenColumns = true,
            borderBetweenRows = false,
            outerBorders = false,
            onFiltersUpdated,
            onSortBy,
            withHeightLimit = false,
            emptyRowsPlaceholder,
            getAdditionalClassName,
            verticalAlign = 'top',
        }: IDataTable,
        ref: Ref<HTMLDivElement>,
    ) => (
        <Table
            ref={ref}
            className={cn(Styles.dataTable, 'dataTable', {
                [Styles.limitHeight]: withHeightLimit,
                [Styles.borderBetweenRows]: borderBetweenRows,
                [Styles.outerBorders]: outerBorders,
            })}
            columns={columns}
            rows={data}
            verticalAlign={verticalAlign}
            headerVerticalAlign="center"
            borderBetweenColumns={borderBetweenColumns}
            borderBetweenRows={borderBetweenRows}
            zebraStriped={zebraStyle}
            filters={filters}
            stickyHeader
            onFiltersUpdated={onFiltersUpdated}
            onSortBy={onSortBy}
            emptyRowsPlaceholder={emptyRowsPlaceholder}
            getAdditionalClassName={getAdditionalClassName}
        />
    ),
);

DataTable.displayName = 'DataTable';
